
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scrap-yards-near-me/[...slug]",
      function () {
        return require("private-next-pages/scrap-yards-near-me/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scrap-yards-near-me/[...slug]"])
      });
    }
  